// extracted by mini-css-extract-plugin
module.exports =  {"event":"mDw3FlZnMlrg0IWzc6u6","numberInput":"U6dIgzYPGE2BDs_UpBnu"};